export default class InsuranceSettingsDTO {
    generalLiabilityRequired: null | boolean = null;
    professionalLiabilityRequired: null | boolean = null;
    workersCompensationRequired: null | boolean = null;
    disabilityRequired: null | boolean = null;
}
